"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  en: {
    headingHide: 'Hide terms and conditions',
    headingView: 'View terms and conditions',
    nonIndexedTitle: 'The following applies to all terms and conditions above',
    expandLabel: 'Expand',
    collapseLabel: 'Collapse'
  },
  fr: {
    headingHide: 'Masquer les modalités et conditions',
    headingView: 'Voir les modalités et conditions',
    nonIndexedTitle: 'Ce qui suit s’applique aux modalités et conditions ci-dessus',
    expandLabel: 'Détailler',
    collapseLabel: 'Réduire'
  }
};